import React from 'react';

import { gallery } from '../../data/images';

const [instaImg1, instaImg2, instaImg3, instaImg4, instaImg5, instaImg6] = gallery;

const OffCanvasInsta = () => {
  return (
    <div className="it-offcanvas-insta d-none d-xl-block mt-50">
      <div className="row gx-10">
        <div className="col-xl-3 mb-10">
          <div className="it-offcanvas-insta-item">
            <a href="#">
              <img className="w-100" src={instaImg1} alt="" />
            </a>
          </div>
        </div>
        <div className="col-xl-3 mb-10">
          <div className="it-offcanvas-insta-item">
            <a href="#">
              <img className="w-100" src={instaImg2} alt="" />
            </a>
          </div>
        </div>
        <div className="col-xl-3 mb-10">
          <div className="it-offcanvas-insta-item">
            <a href="#">
              <img className="w-100" src={instaImg3} alt="" />
            </a>
          </div>
        </div>
        <div className="col-xl-3 mb-10">
          <div className="it-offcanvas-insta-item">
            <a href="#">
              <img className="w-100" src={instaImg4} alt="" />
            </a>
          </div>
        </div>
        <div className="col-xl-3 mb-10">
          <div className="it-offcanvas-insta-item">
            <a href="#">
              <img className="w-100" src={instaImg3} alt="" />
            </a>
          </div>
        </div>
        <div className="col-xl-3 mb-10">
          <div className="it-offcanvas-insta-item">
            <a href="#">
              <img className="w-100" src={instaImg5} alt="" />
            </a>
          </div>
        </div>
        <div className="col-xl-3 mb-10">
          <div className="it-offcanvas-insta-item">
            <a href="#">
              <img className="w-100" src={instaImg6} alt="" />
            </a>
          </div>
        </div>
        <div className="col-xl-3 mb-10">
          <div className="it-offcanvas-insta-item">
            <a href="#">
              <img className="w-100" src={instaImg1} alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OffCanvasInsta;
